import { PIECES, COLS } from './constants.js';

export class Piece {
    constructor(ctx) {
        this.ctx = ctx;
        this.spawn();
    }

    spawn() {
        const pieces = Object.keys(PIECES);
        const randomPiece = pieces[Math.floor(Math.random() * pieces.length)];
        const pieceData = PIECES[randomPiece];

        this.shape = pieceData.shape;
        this.color = pieceData.color;
        this.pieceType = randomPiece; // Store the piece type
        this.x = Math.floor(COLS / 2) - Math.floor(this.shape[0].length / 2);
        this.y = 0;
        this.yFloat = 0; // For smooth visual movement
    }

    draw() {
        this.ctx.fillStyle = this.color;
        this.shape.forEach((row, y) => {
            row.forEach((value, x) => {
                if (value > 0) {
                    this.ctx.fillRect(this.x + x, this.y + y + this.yFloat, 1, 1);
                    this.ctx.strokeStyle = '#000';
                    this.ctx.lineWidth = 0.05;
                    this.ctx.strokeRect(this.x + x, this.y + y + this.yFloat, 1, 1);
                }
            });
        });
    }

    move(p) {
        this.x = p.x;
        this.y = p.y;
        this.shape = p.shape;
    }

    rotate() {
        const rotated = [];
        for (let i = 0; i < this.shape[0].length; i++) {
            rotated[i] = [];
            for (let j = this.shape.length - 1; j >= 0; j--) {
                rotated[i].push(this.shape[j][i]);
            }
        }
        return rotated;
    }

    getNextPosition(dx, dy) {
        return {
            x: this.x + dx,
            y: this.y + dy,
            shape: this.shape
        };
    }

    getRotatedPosition() {
        return {
            x: this.x,
            y: this.y,
            shape: this.rotate()
        };
    }
}